import { useMemo } from 'react';
import { AccountFeature, useAccountFeature } from 'hooks/use-account-feature';
import { useAiFeatureFlags } from 'hooks/use-feature-flags';
import { useIsRmAgentEnabled } from 'hooks/use-rm-agent';
import { getVisibleNitroClawAgentItems } from './nitro-claw-desktop-sidebar.config';
export const useVisibleNitroClawAgentItems = ()=>{
    const [isMigrationAgentEnabled] = useAccountFeature(AccountFeature.MigrationAgent);
    const [isWorkforceAgentEnabled] = useAccountFeature(AccountFeature.WorkforceAgent);
    const [isAutopilotAgentEnabled] = useAccountFeature(AccountFeature.AutopilotAgent);
    const { isNitroAnalystEnabled, isDocumentationAgentEnabled } = useAiFeatureFlags();
    const isRmAgentEnabled = useIsRmAgentEnabled();
    return useMemo(()=>getVisibleNitroClawAgentItems({
            nitroAnalyst: isNitroAnalystEnabled,
            migrationAgent: isMigrationAgentEnabled,
            workforceAgent: isWorkforceAgentEnabled,
            rmAgent: isRmAgentEnabled,
            documentationAgent: isDocumentationAgentEnabled,
            autopilotAgent: isAutopilotAgentEnabled
        }), [
        isNitroAnalystEnabled,
        isMigrationAgentEnabled,
        isWorkforceAgentEnabled,
        isRmAgentEnabled,
        isDocumentationAgentEnabled,
        isAutopilotAgentEnabled
    ]);
};
